import rubrik_desktop from './../static/animations/rubrik_desktop.json';
import { gsap } from "gsap";
import lottie from 'lottie-web';
import LottieScene from './LottieScene';
require('intersection-observer');

export const bikeScene = () => {
  const limitFps = false; // limit to AfterEffects fps (eg 30fps)
  const canvas = false;
  let anims = []; // an array of all the lottie anim instances

  // Add Fallbacks class for reduced motion
  let fallbacks = [...document.querySelectorAll('[data-scene]')];

  fallbacks.map(fallback => {
    fallback.classList.add('fallback'); // TODO: Fix fallback images
  });

  // Use fallbacks images instead of animations
  // in case the user preferes a reduced motion experience
  let motionQuery = matchMedia('(prefers-reduced-motion)');
  function handleReduceMotionChanged() {
    if (motionQuery.matches) {
      // Reduced motion
      const scenes = [...hero.querySelectorAll('[data-scene]')];

      scenes.map(scene => {
        scene.classList.add('fallback');
      });
      anims.map(anim => {
        anim.destroy();
      })
      anims = [];
    } else {
      // standard motion

      // NYA styr&ställ
      const nya = new LottieScene(document.querySelector('[data-scene="nya"]'), limitFps, canvas, false, true);
      nya.init(0);
      anims.push(nya);

      // rubrik_desktop
      const rubrikDesktop = new LottieScene(document.querySelector('[data-scene="rubrik_desktop"]'), limitFps, canvas, '(max-width: 600px)', true);
      rubrikDesktop.init(0);
      rubrikDesktop.loopBetween([60, 119]);
      anims.push(rubrik_desktop);

      // arrow
      const arrow = new LottieScene(document.querySelector('[data-scene="arrow"]'), limitFps, canvas, false, true);
      arrow.init(0);
      anims.push(arrow);

      // Text till mobil
      const cyklar_1750 = new LottieScene(document.querySelector('[data-scene="1750_cyklar"]'), limitFps, canvas, false, true);
      cyklar_1750.init(0);
      // cyklar_1750.loopBetween([30, 60], false);
      anims.push(cyklar_1750);

      const sadel = new LottieScene(document.querySelector('[data-scene="justerbar_sadel"]'), limitFps, canvas, false, true);
      sadel.init(0);
      sadel.loopBetween([23, 300], false);
      anims.push(sadel);

      const handtag = new LottieScene(document.querySelector('[data-scene="handtag"]'), limitFps, canvas, false, true);
      handtag.init(0);
      anims.push(handtag);

      const speedlines = new LottieScene(document.querySelector('[data-scene="speedlines"]'), limitFps, canvas, false, true);
      speedlines.init(0);
      anims.push(speedlines);

      const gears = new LottieScene(document.querySelector('[data-scene="gears"]'), limitFps, canvas, false, true);
      gears.init(0);
      gears.loopBetween([30, 60], false);
      anims.push(gears);

      const bell = new LottieScene(document.querySelector('[data-scene="bell"]'), limitFps, canvas, false, true);
      bell.init(0);
      anims.push(bell);

      const light = new LottieScene(document.querySelector('[data-scene="light"]'), limitFps, canvas, false, true);
      light.init(0);
      anims.push(light);



      // lättare
      /*
      1-36 = intro
      60-90 = lyft
      90-150 = svävande loop
      150-162 =landar
      */
      const lighterDom = document.querySelector('[data-scene="lighter"]');
      const lighter = new LottieScene(lighterDom, limitFps, canvas, false, false);
      lighter.init(0);
      lighter.loopBetween([1, 36], true);
      anims.push(lighter);


      // animations to controll the floating bike animation
      const thebike = document.getElementById('thebike');

      var bike_tl, bikeMove, speedMove;

      const speedlinesDom = document.querySelector('[data-scene="speedlines"]')

      const createBikeAnim = () => {
        lighter.loopBetween([60, 150], true);
        speedMove = gsap.to(speedlinesDom, { opacity: 0, duration: 0.3, ease: "none" });
        bike_tl = gsap.timeline();
        bike_tl.to(thebike, { duration: 4, ease: "power2.out", y: -150, x: 0 }, 0);
        bike_tl.to(thebike, { duration: 2, ease: "power2.out", rotate: 10, x: 0 }, 0);
        bike_tl.to(thebike, { duration: 5, ease: "power2.inOut", rotate: -5, x: 0 }, 2);

        bike_tl.to(thebike, { duration: 4, ease: "power2.inOut", y: -100 }, 4);
        bike_tl.to(thebike, { duration: 4, ease: "power2.inOut", rotate: 5 }, 7);

        bike_tl.to(thebike, { duration: 4, ease: "power2.inOut", y: -150 }, 8);

        bike_tl.to(thebike, { duration: 4, ease: "power2.inOut", y: 0, rotate: 0 }, 12);
      }


      lighterDom.addEventListener('mouseenter', () => {
        bikeMove && bikeMove.kill();
        bike_tl && bike_tl.kill();
        speedMove && speedMove.kill();
        createBikeAnim();
      });

      lighterDom.addEventListener('click', () => {
        bikeMove && bikeMove.kill();
        bike_tl && bike_tl.kill();
        speedMove && speedMove.kill();
        createBikeAnim();
      });

      lighterDom.addEventListener('mouseleave', () => {
        bikeMove && bikeMove.kill();
        bike_tl && bike_tl.kill();
        speedMove && speedMove.kill();
        bikeMove = gsap.to(thebike, { rotate: 0, x: 0, y: 0, duration: 1, ease: "bounce.out" });
        speedMove = gsap.to(speedlinesDom, { opacity: 1, duration: 0.3, delay: 1, ease: "none" });
        // speedlinesDom.style.opacity = 1;
        lighter.loopBetween([150, 162], true);
      });


      // Move bike based on scroll
      var observerCallback = (entries) => {

        entries.forEach(entry => {
          // Set scroll direction
          // See https://stackoverflow.com/questions/46478202/how-do-i-know-the-intersectionobserver-scroll-direction

          if (entry.isIntersecting & entry.intersectionRatio > 0.25) {

            bikeMove = gsap.to(thebike, { x: 0, duration: 2, ease: "power4.out" });
            speedMove = gsap.to(speedlinesDom, { opacity: 1, duration: 0.3, delay: 1, ease: "none" });
          }
          // Else move back
          else {
            bikeMove = gsap.to(thebike, { x: '-100%', duration: 1, ease: "power4.out" });
            speedMove = gsap.to(speedlinesDom, { opacity: 0, duration: 0.3, ease: "none" });
          }
        });
      };

      var options = {
        threshold: [0, 0.25, 0.75, 1]
      }

      var observer = new IntersectionObserver(observerCallback, options);

      observer.observe(document.getElementById('cykeln'));
    }
  }
  motionQuery.addListener(handleReduceMotionChanged);
  handleReduceMotionChanged(); // trigger once on load if needed

  // Global Settings
  lottie.setQuality('low');


}


// Always, runs, but returns false when not needed to run
// defaultHero();

export default bikeScene;
